import React from 'react';
import { FadeIn } from './FadeIn';
export function UniqueMechanism() {
  return <section className="bg-brand-dark text-brand-cream py-24 px-6 relative overflow-hidden" data-id="element-189">
      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-190">
        <FadeIn data-id="element-191">
          <span className="text-brand-gold uppercase tracking-widest text-sm font-bold mb-4 block" data-id="element-192">
            El Mecanismo Único
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mb-8 text-brand-cream" data-id="element-193">
            Sistema de Sincronía Tetraédrica
          </h2>
          <p className="text-xl max-w-3xl mx-auto font-light text-brand-cream/80 mb-16" data-id="element-194">
            La riqueza es el resultado de alinear tus cuatro dimensiones
            fundamentales. Cuando estos cuatro cuerpos trabajan juntos, la
            ejecución financiera deja de ser una lucha y se convierte en un
            flujo natural de decisiones acertadas y energía inagotable.
          </p>
        </FadeIn>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-12" data-id="element-195">
          {[{
          name: 'Física',
          icon: 'M13 10V3L4 14h7v7l9-11h-7z'
        }, {
          name: 'Mental',
          icon: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z'
        }, {
          name: 'Emocional',
          icon: 'M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z'
        }, {
          name: 'Espiritual',
          icon: 'M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z'
        }].map((pillar, index) => <FadeIn key={index} delay={index * 0.1} className="flex flex-col items-center" data-id="element-196">
              <div className="w-20 h-20 rounded-full border border-brand-gold/40 flex items-center justify-center mb-4 bg-brand-green/50" data-id="element-197">
                <svg className="w-8 h-8 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-198">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={pillar.icon} data-id="element-199" />
                </svg>
              </div>
              <h3 className="font-serif text-xl text-brand-gold" data-id="element-200">
                {pillar.name}
              </h3>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}